@let userPhotoUrl = getUserPhotoUrl();
@let userName = getUserName();
@let userOrgCode = getUserOrgCode();

<div sag-ui-avatar-base class="flex items-center min-w-0">
    @if (userPhotoUrl) {
        <div
            sag-ui-avatar
            class="flex-shrink-0"
            [imageUrl]="userPhotoUrl"
            [altText]="'header.user-profile.title' | translate: { userName: userName }"
        ></div>
    } @else {
        <div sag-ui-avatar class="flex-shrink-0"></div>
    }
    @if (showData()) {
        <div class="min-w-0 overflow-hidden">
            <p class="text-sm truncate" sag-ui-avatar-name>{{ userName }}</p>
            <p class="text-light-textColorSecondary dark:text-dark-textColorSecondary truncate" sag-ui-avatar-org>
                {{ userOrgCode }}
            </p>
        </div>
    }
</div>
